module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/plan2-3-401c680f34dd8bb8cf2ced55cd14d188.webp";